import type { MapIcon } from 'features/mapping/mapping.types';
import * as wildfireIcons from './iconData/wildfireIcons';

export type WildfireIconSet = typeof wildfireIcons;

/** Wildfire pin icons registered as Mapbox images (excludes complex markers). */
export const getWildfireMapRasterIcons = (): MapIcon[] => {
  return [
    wildfireIcons.ActiveFireIcon,
    wildfireIcons.SelectedActiveFireIcon,
    wildfireIcons.ActivePrescribedFireIcon,
    wildfireIcons.SelectedActivePrescribedFireIcon,
    wildfireIcons.ActiveFire75Icon,
    wildfireIcons.SelectedActiveFire75Icon,
    wildfireIcons.ActiveFire50Icon,
    wildfireIcons.SelectedActiveFire50Icon,
    wildfireIcons.ActiveFire100Icon,
    wildfireIcons.SelectedActiveFire100Icon,
    wildfireIcons.InactiveFireIcon,
    wildfireIcons.SelectedInactiveFireIcon,
    wildfireIcons.SilentActiveFireIcon,
    wildfireIcons.SelectedSilentActiveFireIcon,
    wildfireIcons.ScheduledFireIcon,
    wildfireIcons.SelectedScheduledFireIcon,
    wildfireIcons.SilentInactiveFireIcon,
    wildfireIcons.SelectedSilentInactiveFireIcon,
  ];
};

export const WILDFIRE_MAP_RASTER_ICON_NAMES = getWildfireMapRasterIcons().map(
  (icon) => icon.name,
);

export const WILDFIRE_ICON_TO_SELECTED_NAME: Record<string, string> = {
  [wildfireIcons.ActiveFireIcon.name]:
    wildfireIcons.SelectedActiveFireIcon.name,
  [wildfireIcons.ActivePrescribedFireIcon.name]:
    wildfireIcons.SelectedActivePrescribedFireIcon.name,
  [wildfireIcons.ActiveFire75Icon.name]:
    wildfireIcons.SelectedActiveFire75Icon.name,
  [wildfireIcons.ActiveFire50Icon.name]:
    wildfireIcons.SelectedActiveFire50Icon.name,
  [wildfireIcons.ActiveFire100Icon.name]:
    wildfireIcons.SelectedActiveFire100Icon.name,
  [wildfireIcons.InactiveFireIcon.name]:
    wildfireIcons.SelectedInactiveFireIcon.name,
  [wildfireIcons.SilentActiveFireIcon.name]:
    wildfireIcons.SelectedSilentActiveFireIcon.name,
  [wildfireIcons.ScheduledFireIcon.name]:
    wildfireIcons.SelectedScheduledFireIcon.name,
  [wildfireIcons.SilentInactiveFireIcon.name]:
    wildfireIcons.SelectedSilentInactiveFireIcon.name,
};
